// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar__hZ3ZU"};